import React, { useContext, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './ResetPasswordPage.css';

export default function ResetPasswordPage() {
  const { completePasswordReset } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const [form, setForm] = useState({
    password: '',
    passwordConfirmation: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    if (!code) {
      setError('This reset link is missing a reset code.');
      return;
    }

    if (form.password !== form.passwordConfirmation) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);

    try {
      await completePasswordReset({
        code,
        password: form.password,
        passwordConfirmation: form.passwordConfirmation,
      });
      setSuccess('Your password has been updated. You are now signed in.');
      setForm({ password: '', passwordConfirmation: '' });
    } catch (err) {
      setError(err.message || 'Unable to reset password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="reset-password-page">
      <section className="reset-password-panel">
        <h1>Reset password</h1>
        {!code ? (
          <>
            <p className="reset-password-copy">
              This reset link is missing a code. Request a new reset link from the report login form.
            </p>
            <Link className="reset-password-button" to="/reports">
              Back to reports
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="reset-password-field">
              <label htmlFor="new-password">New password *</label>
              <input
                type="password"
                id="new-password"
                name="password"
                value={form.password}
                onChange={handleChange}
                required
                disabled={loading || Boolean(success)}
              />
            </div>
            <div className="reset-password-field">
              <label htmlFor="confirm-password">Confirm new password *</label>
              <input
                type="password"
                id="confirm-password"
                name="passwordConfirmation"
                value={form.passwordConfirmation}
                onChange={handleChange}
                required
                disabled={loading || Boolean(success)}
              />
            </div>
            {error && <div className="reset-password-message reset-password-error">{error}</div>}
            {success && <div className="reset-password-message reset-password-success">{success}</div>}
            <button type="submit" className="reset-password-button" disabled={loading || Boolean(success)}>
              {loading ? 'Updating...' : 'Update password'}
            </button>
            {success && (
              <Link className="reset-password-secondary-link" to="/reports">
                Continue to reports
              </Link>
            )}
          </form>
        )}
      </section>
    </main>
  );
}
